import { render, staticRenderFns } from "./RegistrarLink.vue?vue&type=template&id=7ee52aab&"
import script from "./RegistrarLink.vue?vue&type=script&lang=js&"
export * from "./RegistrarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports